<template>
    <UModal v-model="open" class="product-review_modal" :ui="{
        width: 'w-full sm:max-w-md',
        overlay: {
            background: 'my-modal-overlay',
        },
    }">
        <form class="p-8 flex flex-col gap-8" @submit.prevent="sendForm">
            <div class="flex w-full justify-between align-center">
                <div class="modal-header">{{ t('writeReview2') }}</div>
                <div style="transform: rotateZ(45deg); cursor: pointer" @click="open = false">
                    <Icon name="ph:plus" size="24" />
                </div>
            </div>
            <input type="text" class="base-input secondary w-full" :placeholder="t('yourName')"
                :class="{ error: validator.client_name.$error }" v-model="form.client_name" />
            <div>
                <p class="text mb-2">{{ t('clickForRate') }}</p>
                <div class="flex gap-2 border-2 border-solid border-transparent"
                    :class="{ error: validator.rating.$error }">
                    <Icon name="twemoji:star" size="32" v-for="i in form.rating" @click="form.rating = i"
                        style="cursor: pointer" />
                    <Icon name="clarity:star-solid" size="32" v-for="i in (5 - form.rating)"
                        @click="form.rating = form.rating + i" style="color: gray;cursor: pointer" />
                </div>
            </div>
            <textarea :class="{ error: validator.comment.$error }" v-model="form.comment" class="base-input secondary"
                rows="4" :placeholder="t('review')"></textarea>
            <button class="my-btn flex align-center justify-center cursor-pointer" style="width: 100%">{{ t('send')
                }}</button>
        </form>
    </UModal>
</template>

<script setup>
import { useVuelidate } from '@vuelidate/core'
import { required, minValue } from '@vuelidate/validators'
const rc = useRuntimeConfig()
const { locale, t } = useI18n()
const { start, finish } = useLoadingIndicator()
const open = defineModel()
const props = defineProps(['productId'])
const emits = defineEmits(['reviewSent'])
const toast = useToast()
const form = reactive({
    client_name: '',
    rating: 0,
    comment: '',
    product_id: props.productId
})

const rules = computed(() => ({
    client_name: { required },
    rating: { minValue: minValue(1) },
    comment: { required },
}))

const validator = useVuelidate(rules, form)
async function sendForm() {
    const isValid = await validator.value.$validate()
    if (!isValid) return toast.add({
        title: t('fillForm'),
        color: 'red'
    });
    try {
        start()
        await $fetch(rc.public.api + '/api/review', {
            body: form,
            method: 'POST'
        })
        toast.add({
            title: t('reviewSent'),
        })
        resetForm();
        open.value = false
        emits('reviewSent')
    } catch (error) {
        console.log(error)
        toast.add({
            title: error?.data?.context?.message || error?.data?.message || t('errorOccured'),
            color: 'red'
        })
    } finally {
        finish()
    }
}

function resetForm() {
    form.client_name = form.comment = '';
    form.rating = 0;
    validator.value.$reset()
}
watch(open, resetForm)
</script>